import { Article } from '@api/api';
import { articleApiClient } from '@api/clients';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { useWriterArticlesCount } from 'queries/useWriterArticlesCount';

const limit = 9;

export const fetchWriterArticles = async (
  authorID: string,
  pageParam = 0
): Promise<{ page: number; items: Article[] }> => {
  const { data } = await articleApiClient.articlesGet(
    {
      limit,
      start: pageParam ?? 0,
      sort: 'published_at:DESC',
    },
    { params: { 'author.id': authorID } },
  );

  return { page: pageParam, items: data };
};

export const useWriterArticles = (
  authorID: string,
): UseInfiniteQueryResult => {
  const { data: writerArticlesCount } = useWriterArticlesCount(authorID);
  const totalPages = Math.ceil(writerArticlesCount / limit);

  return useInfiniteQuery(
    ['writer-articles', authorID], (context) => fetchWriterArticles(authorID, context.pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages.length !== totalPages ? lastPage.page + limit : false;
      },
    },
  );
};
